import { render, staticRenderFns } from "./ItemFilterAuctionLayout.vue?vue&type=template&id=3c22a8ab&scoped=true"
import script from "./ItemFilterAuctionLayout.vue?vue&type=script&lang=js"
export * from "./ItemFilterAuctionLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c22a8ab",
  null
  
)

export default component.exports